module.exports = __webpack_public_path__ + "img/guide_music_btn3.9ec50e92.png";